var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectResidents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4179 20.164C14.1633 20.164 13.9059 20.0667 13.7113 19.8707L10.5459 16.7067C10.1553 16.316 10.1553 15.684 10.5459 15.2933C10.9366 14.9027 11.5686 14.9027 11.9593 15.2933L14.4179 17.7493L20.0393 12.1293C20.4299 11.7387 21.0619 11.7387 21.4526 12.1293C21.8433 12.52 21.8433 13.152 21.4526 13.5427L15.1246 19.8707C14.9299 20.0667 14.6739 20.164 14.4179 20.164Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectResidents);
export default __webpack_public_path__ + "static/media/iconSelectResidents.b263065908ccd06d38449e7c409ad78e.svg";
export { ForwardRef as ReactComponent };